import { component as MODULE } from '../store/state';

const MUTATIONS = {
  SAMPLE: `${MODULE}sample`,

  SET_USER: `${MODULE}user`,
};

export default MUTATIONS;
